<script>
import Multiselect from 'vue-multiselect'
export default {
    components: {
        Multiselect
    },
    props: {
      isVisibleCSVButton: {
        type: Boolean,
        default: false
      },
      isVisibleSearch: {
        type: Boolean,
        default: false
      },
    },
    data () {
      return {
        perPage: 10,
        perPageOptions: [10, 20, 30, 40, 50, 'Todos'],

        searchQuery: '',
        typingTimer: null,
        doneTypingInterval: 500 // milliseconds
      }
    },
    methods: {
      handleInput() {
      clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(() => {
          this.cleanQuery();
          this.handleChange();
        }, this.doneTypingInterval);
      },
      cleanQuery() {
        this.searchQuery = this.searchQuery.trim();
        // this.searchQuery = this.searchQuery.replace(/[^\w\s]/gi, '');
      },
      handleChange() {
        // Do whatever you want to do with the search query here
        this.$emit('changeSearchQuery', this.searchQuery)
      }
      
    },
    watch: {
      perPage(val) {
        this.$emit('changePerPage', val)
      },
    }
}

</script>

<template>
  <div>
    <slot name="actions"></slot>
    <div class="row mb-2">
      <div class="col-md-2">
        <div style="display: flex; gap: 10px; align-items: center;">
          Mostrar
          <select class="form-control" style="min-width: 75px;" v-model="perPage">
            <option v-for="optionValue in perPageOptions" :key="optionValue">{{ optionValue }}</option>
          </select>
          <span class="d-none d-lg-inline">Registros</span>
        </div>
      </div>
      <div class="col-md-10">
        <div style="display: flex; justify-content: flex-end; align-items: flex-end; gap: 5px;">
          <div style="display: flex; align-items: center; gap: 5px;" v-if="isVisibleSearch">
            <input 
              type="text" 
              class="form-control" 
              style="display: inline-block; max-width: 200px;"
              placeholder="Buscar"
              v-model="searchQuery" @input="handleInput"
            />
          </div>
          <button 
            type="button"
            v-if="isVisibleCSVButton"
            class="btn btn-default buttons-pdf buttons-html5" 
            style="margin: 0;"
            @click="$emit('csvClick')"
          >
            CSV
          </button>
        </div>
      </div>     
    </div>
  </div>
</template>